module.exports = __webpack_public_path__ + "static/img/human2.3105dc0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/human2.png
// module id = 7uwB
// module chunks = 1